// Pure parsers for the watch wizards' JSON/number text fields (tool args,
// transform bindings, sandbox timeout). Both wizards (thread + group) share
// them so their validation messages and empty-input semantics stay in lockstep.
// Empty text parses to `undefined` — callers decide their own default
// (args default to `{}`, bindings are omitted).

/**
 * Parse a textarea's contents as a JSON object. Empty input is "unset", not
 * an error. Arrays and primitives are rejected — the API expects a record.
 */
export function parseJsonObjectText(
  text: string,
  label: string,
): { value?: Record<string, unknown>; error?: string } {
  const trimmed = text.trim();
  if (trimmed === '') return { value: undefined };
  try {
    const v: unknown = JSON.parse(trimmed);
    if (v !== null && typeof v === 'object' && !Array.isArray(v)) {
      return { value: v as Record<string, unknown> };
    }
    return { error: `${label} must be a JSON object` };
  } catch {
    return { error: `${label} is not valid JSON` };
  }
}

/**
 * Parse a sandbox-timeout text field (ms). Bounds mirror the API schema
 * (`timeoutMs`: int, 100..30_000). Empty input is "unset" → server default.
 */
export function parseTimeoutMs(text: string): { value?: number; error?: string } {
  const trimmed = text.trim();
  if (trimmed === '') return { value: undefined };
  const n = Number(trimmed);
  if (!Number.isInteger(n) || n < 100 || n > 30_000) {
    return { error: 'Timeout must be a whole number of ms between 100 and 30000' };
  }
  return { value: n };
}
